import {LogService as LogServiceType} from 'services/log/types';
import {analyticsService} from 'services/analytics';
import {logService} from 'services/log';
import {createProxy} from 'interactors/errorHandler';

interface Dependencies {
  service?: AnalyticsService;
  logger?: LogServiceType;
}

export function create({
  service = analyticsService,
  logger = logService,
}: Dependencies = {}): AnalyticsService {
  const methods = ['create'];
  const handler = logger.log;
  return createProxy({service, methods, handler});
}
